import React from "react";

export default function NumberField({ field, value, onChange }) {
  return (
    <div className="mp-form-group">
      <label className="mp-form-label">{field._label}{field.required && " *"}</label>
      <input
        type="number"
        className="mp-form-input"
        value={value ?? ""}
        onChange={e => onChange(field.name, e.target.value === "" ? null : Number(e.target.value))}
      />
    </div>
  );
}
